import React, { useState } from 'react';
import Customer from '../../../types/Customer';
import AdminRadiobox from '../../admin-radiobox';
import useUpdateCustomerStatus from '../../../hooks/use-update-customer-status';
import Button from '../../button';

interface Props {
  customer: Customer;
}

const AdminUserStatusForm: React.FC<Props> = ({ customer }) => {
  const isGovernmentUser = customer.role.toLowerCase() === 'government';
  const [status, setStatus] = useState(
    customer.enabled ? 'USR_ENB' : 'USR_DSB'
  );
  const [message, setMessage] = useState('');
  const updateCustomerStatus = useUpdateCustomerStatus();

  const onClick = () => {
    if (isGovernmentUser) {
      setMessage('You cannot change the status of a government user.');
      return;
    }

    updateCustomerStatus(process.env.SITE!, customer.id, status);
    setMessage('Successfully updated status details.');
  };

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
    }}>
      <h2>Status</h2>
      <div className="statuses">
        {[
          {
            id: 'USR_ENB',
            label: 'Enabled',
          },
          {
            id: 'USR_DSB',
            label: 'Disabled',
          },
          // @ts-ignore
        ].map((s) => (
          <AdminRadiobox
            key={s.id}
            name="status"
            id={s.id}
            label={s.label}
            checked={s.id.toLowerCase() === status.toLowerCase()}
            onChange={() => setStatus(s.id)}
          />
        ))}
      </div>
      {message && <p>{message}</p>}
      <Button text="Save" onClick={onClick} />
      {/* language=CSS */}
      <style jsx>{`
        .statuses {
          display: flex;
          flex-wrap: wrap;
        }

        .statuses > :global(.radiobox-group) {
          flex-grow: 0;
          width: 33%;
          margin-bottom: 1rem;
        }
      `}</style>
    </form>
  );
};

export default AdminUserStatusForm;
